import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getAllMajors } from '../../redux/actions/majorActions'
import { Form } from 'react-bootstrap'
import { useFormContext } from 'react-hook-form'

const Majors = ({ getAllMajors, majors }) => {

  const { register } = useFormContext();

  useEffect( () => {
    !majors.length && getAllMajors()
   }, [])

   return (
     <Form.Control as="select" id="carrera_id" {...register('carrera_id', { required: true })}>
       <option value=''>SELECCIONAR CARRERA</option>
       {
         majors.map( major => <option key={'carrera_id-'+major.value} value={major.value}>{major.label}</option> )
       }
     </Form.Control>
   )
}

export default connect(({ majorsReducer }) => ({ majors : majorsReducer }),{ getAllMajors })(Majors)